// extracted by mini-css-extract-plugin
export default {"row":"PageLayout2_row__z+0A8","column1":"PageLayout2_column1__-scch","leftcard1":"PageLayout2_leftcard1__4U1Ih"};